// import axiosIns from '../utils/axios'
import { service as axiosIns } from '../utils/axios';
export const headerForm = {
    'content-type': 'application/x-www-form-urlencoded'
};

export const headerJson = {
    'content-type': 'application/json'
};

/**
 * 指标数据
 * @param {*} data
 */
export function indexData(data) {
    return axiosIns({
        url: 'ncdpPersonalHealth/metric/datas',
        method: 'GET',
        data
    })
}

// 查看量表作答记录
export function getAnswerDetail(params) {
  return axiosIns({
      url: `projectSurvey/getAnswerDetail/${params.memberCode}/${params.surveyAnswerId}`,
      method: 'GET'
  })
}



// WEBPACK FOOTER //
// ./src/api/indexData.js